import { rewritePortalPath } from 'lib/hooks/usePortalNavigate';

export const wantsNewTab = (event) =>
  !!event && (event.metaKey || event.ctrlKey || event.shiftKey || event.button === 1);

export const openInNewTab = (path) => window.open(rewritePortalPath(path), '_blank', 'noopener');
